import React from "react";
import { Navigate } from "react-router-dom";

const CenterAdminRoute = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.role === "centerAdmin") {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

export default CenterAdminRoute;